import { useBasketTotals, useLocale, useAppContext } from "hooks"
import React, { useEffect, useState } from "react"
import { useUser } from "lib/user"
import { ProgressBar } from "packages/ui-shared/components/ProgressBar/ProgressBar"
import { container, textStyle } from "./RafDiscountProgressBar.css"

export const RafDiscountProgressBar: React.FC = () => {
  const { totalMembersPrice, totalTypicalPrice } = useBasketTotals()
  const { hasMembership } = useUser()
  const locale = useLocale()
  const { currencySymbol } = useAppContext()
  const [amount, setAmount] = useState(0)
  const [threshold, setThreshold] = useState(0)

  useEffect(() => {
    setThreshold(locale === "en-GB" ? 60 : 80)
  }, [locale])

  useEffect(() => {
    setAmount(hasMembership ? totalMembersPrice : totalTypicalPrice)
  }, [totalMembersPrice, totalTypicalPrice, hasMembership])

  return (
    <div className={container}>
      <span className={textStyle}>
        {amount >= threshold
          ? "Referral discount applied to your order!"
          : `Spend ${currencySymbol}${(threshold - amount).toFixed(
              2
            )} more to get your referral discount`}
      </span>
      <ProgressBar
        percentProgress={`${(100 / threshold) * amount}%`}
        ariaLabel={"Refer a friend progress bar"}
      />
    </div>
  )
}
